import {Directive} from '@angular/core';

@Directive({
  selector: '[regex]'
})
export class RegexDirective {

  static Contains(value: string, contains: string): boolean {
    // Returns a boolean
    const regExp = new RegExp(contains, 'g');
    return regExp.test(value);
  }
  static EndsWith(value: string, endsWith: string): boolean {
    // Returns a boolean
    const regExp = new RegExp(endsWith + '$', 'g');
    return regExp.test(value);
  }
  static StartsWith(value: string, startsWith: string): boolean {
    // Returns a boolean
    const regExp = new RegExp('^' + startsWith, 'g');
    return regExp.test(value);
  }
  static RegExBuilder(value: string, operator: string): RegExp {
    let regExp;
    switch (operator) {
      case 'startsWith':
        regExp = new RegExp('^' + value, 'g');
        break;
      case 'contains':
        regExp = new RegExp(value, 'g');
        break;
      case 'endsWith':
        regExp = new RegExp(value + '$', 'g');
        break;
      case 'doesNotStartWith':
        regExp = new RegExp('^(?!' + value + ').+', 'g');
        break;
      case 'doesNotEndWith':
        regExp = new RegExp('.+(?<!' + value + ')$', 'gm');
        break;
      case 'doesNotContain':
        regExp = new RegExp('^((?!' + value + ').)*$', 'gm');
        break;
      default:
        // defaults to startsWith
        regExp = new RegExp('^' + value, 'g');
    }
    return regExp;
  }
}
